/**
 * Created by emhaje-workspace on 6/14/17.
 */
import { MOKA_INVENTORY_API } from 'api/constants';

export const V1_PURCHASE_ORDER = `${MOKA_INVENTORY_API}/v1/ingredient_purchase_orders`;

export const V1_SEARCH_PURCHASE_ORDER = `${V1_PURCHASE_ORDER}/search`;

export const V1_EXPORT_PURCHASE_ORDER = `${V1_PURCHASE_ORDER}/export`;

export const V1_EXPORT_TEMPLATE_PURCHASE_ORDER = `${V1_PURCHASE_ORDER}/export_template`;

export const V1_IMPORT_PURCHASE_ORDER = `${V1_PURCHASE_ORDER}/import`;

export const V1_IMPORT_TEMPORARY_PURCHASE_ORDER = `${V1_PURCHASE_ORDER}/import_temporary`;

export const V1_PURCHASE_ORDER_BY_ID = id => `${V1_PURCHASE_ORDER}/${id}.json`;

export const V1_PRINT_PURCHASE_ORDER = id =>
  `${V1_PURCHASE_ORDER}/${id}/download.pdf`;

export const V1_RESEND_EMAIL_PURCHASE_ORDER = id =>
  `${V1_PURCHASE_ORDER}/${id}/resend_email`;

export const V1_CREATE_AND_FULFILLED = `${V1_PURCHASE_ORDER}/create_and_fulfilled`;

export const V1_EDIT_PURCHASE_ORDER = id =>
  `${V1_PURCHASE_ORDER}/${id}/edit.json`;

export const V1_UPDATE_PURCHASE_ORDER = id => `${V1_PURCHASE_ORDER}/${id}`;
